import { render, staticRenderFns } from "./ShippingInfoDialog.vue?vue&type=template&id=6f9cb9d5"
import script from "./shipping-info-dialog.ts?vue&type=script&lang=ts&external"
export * from "./shipping-info-dialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports